import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const XOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function XOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="m20.71 4.71-1.42-1.42-7.29 7.3-7.29-7.3-1.42 1.42 7.3 7.29-7.3 7.29 1.42 1.42 7.29-7.3 7.29 7.3 1.42-1.42-7.3-7.29 7.3-7.29Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default XOutlined;